import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import reformatDateToDisplay from "../../../objects/CommonUse/reformatDateToDisplay_function";
import createNotificationObj from "../../../objects/CommonUse/create_notification_obj";
import rollForwardDate from "../objects/roll_forward_date_function";

export const createNotificationForCDMatures = (currentGameDate, nbrMonths, notificationArr, CDList) => {
    const futureDate = rollForwardDate(currentGameDate, nbrMonths);
    const periodStartMonth = currentGameDate.split("-")[1];
    const periodEndMonth = futureDate.split("-")[1];
    for (let i=0; i<CDList.length; i++){
        const CDStartMonth = CDList[i].startDate.split("-")[1];
        if (CDStartMonth > periodStartMonth  &&
            CDStartMonth <= periodEndMonth){
                let autoRolloverText = "Yes";
                if (CDList[i].autoRollover === false){
                    autoRolloverText = "No";
                }
                let additionalInfoArr = [];
                const additionalInfoObj = "You have a Certificate of Deposit (CD) that will mature " +
                    "prior to " + reformatDateToDisplay(futureDate) + ". This CD has a value of " +
                    doubleToStringMonthly(CDList[i].amount) + ". You may want " +
                    "to review/change the autoRollover option for this CD. AutoRollover is currently set to " +
                    autoRolloverText + ".";
                additionalInfoArr.push(additionalInfoObj);
                const notificationObj = createNotificationObj("CDMatures", additionalInfoArr);
                notificationArr.push(notificationObj);
        }
        
    }
}
export default createNotificationForCDMatures;